const blocks = document.querySelectorAll('.animate__block');

const observer = new IntersectionObserver(
	(entries, obs) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				const block = entry.target;

				// Add animate__now once the block hits vertical center
				block.classList.add('animate__now');

				// Get wrappers inside containers
				const containers = block.querySelectorAll('.animate__container');

				containers.forEach((container) => {
					const wrappers = container.querySelectorAll(
						'.animate__container .animate__wrapper'
					);

					wrappers.forEach((wrapper, index) => {
						const span = wrapper.querySelector('span');
						if (span) {
							setTimeout(() => {
								span.classList.add('animate__' + span.dataset.animation);
								span.classList.add('animate__animated');
							}, index * 200); // stagger by 0.3s
						}
					});
				});

				obs.unobserve(block);
			}
		});
	},
	{
		root: null,
		threshold: 0,
		rootMargin: '-20% 0px -20% 0px', // triggers when crossing bottom 25% of screen
	}
);

blocks.forEach((block) => observer.observe(block));
